import React from 'react'
import { View } from 'react-native'
import { StaticIFrame } from 'AppComponents'

export const ArticlesContainer = (props:any) => {
  return (
    <View
      style={{
        flex:1
      }}
    > 
      <StaticIFrame 
        height={3150}
        src={'https://specsandcodes.com/articles/default.html#page_content'}
      />
    </View>
  )
}